/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {ScaleLinear} from "d3-scale";

type Props = {
	yScale: ScaleLinear<number, number, any>,
	width: number,
	height?: number,
	ticks?: number,
	label?: boolean,
	axisPoint?: number,
	tickArray?: any[],
	tickValues?: string[],
	placeInMiddle?: boolean,
	tickLines?: boolean,
	topLine?: boolean,
	minValue?: number,
	linesColor?: string,
	tickSpecificLines?: number[]
}

export class AxisY
	extends BaseComponent<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	axisGridLabels = () => {
		const ticks = this.props.tickArray || this.props.yScale.ticks(this.props.ticks || 6)

		const axis = ticks.map((d, i) => {
			if (this.props.tickSpecificLines?.length && !this.props.tickSpecificLines.includes(i)) {
				return <line
					key={i}
					style={{stroke: "white"}}
					y1={this.props.yScale(d)}
					y2={this.props.yScale(d)}
					x1={this.props.axisPoint || -30}
					x2={this.props.width + 5}
				/>
			}
			return (<g className="y-tick" key={i}>
					{this.props.tickLines && (this.props.ticks && i < this.props.ticks) && <line
											style={{stroke: this.props.linesColor || "#a6aab2"}}
											y1={this.props.yScale(d)}
											y2={this.props.yScale(d)}
											x1={this.props.axisPoint || -30}
											x2={this.props.width + 5}
										/>}
					{/*<text style={{fontSize: 12, fill: this.props.skeleton ? COLORS.grays_1 : COLORS.neutral_text_dark_2}} x={-32} dy=".32em"*/}
					{/*      y={this.props.placeInMiddle ? this.props.yScale(d) + ((this.props.yScale(1) - this.props.yScale(0)) / 2) : this.props.yScale(d)}>*/}
					{/*	{this.props.tickValues ? this.tspans(this.props.tickValues[i]) : this.tspans(d.toString())}*/}
					{/*</text>*/}
				</g>
			)
		});
		return <>{axis}</>;
	};

	tspans = (value: string) => {
		if (!value)
			return;
		if (value.split(" ").length === 1)
			return value;
		return value.split(" ").map((_value, index) => <tspan key={index} style={{fontSize: 12}} x={-34} dy={index > 0 ? '1.2em' : '0.1em'}>{_value}</tspan>);
	};


	axisLine = () => {
		const min = Math.min(...this.props.yScale.ticks(this.props.ticks || 5));
		return <g className="x-line">
			<line
				style={{
					stroke: "#a6aab2", strokeWidth: 1
				}}
				y1={this.props.height || this.props.yScale(min)}
				y2={this.props.height || this.props.yScale(min)}
				x1={this.props.axisPoint || 0}
				x2={this.props.width}
			/>
		</g>;
	};

	topLine = () => {
		const max = Math.max(...this.props.yScale.ticks(this.props.ticks || 5));
		return <g className="x-line">
			<line
				style={{
					stroke: "#a6aab2", strokeWidth: 1
				}}
				y1={this.props.yScale(max)}
				y2={this.props.yScale(max)}
				x1={-30}
				x2={this.props.width + 5}
			/>
		</g>;
	};

	render() {
		return <>
			{this.props.label && this.axisGridLabels()}
			{this.axisLine()}
			{this.props.topLine && this.topLine()}
		</>;
	}
}

export default AxisY;
